import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { bnToU8a, compactToU8a, stringToU8a, u8aConcat, u8aSorted } from '@polkadot/util';
import { blake2AsU8a } from "../blake2/asU8a.mjs";
import { decodeAddress } from "./decode.mjs";
var PREFIX = stringToU8a('modlpy/utilisuba');
export function createKeyMulti(who, threshold) {
  return blake2AsU8a(u8aConcat.apply(void 0, [PREFIX, compactToU8a(who.length)].concat(_toConsumableArray(u8aSorted(who.map(function (who) {
    return decodeAddress(who);
  }))), [bnToU8a(threshold, {
    bitLength: 16,
    isLe: true
  })])));
}